const lendingTypes = {
  LOAN: {
    productName: 'loan',
    productDescription: 'unsecured business loan (£25,001 to £250,000)',
    productLimitName: 'loan value',
    lendingAmountLabel: 'How much is your business looking to borrow?',
    minimumLendingAmount: 25001,
    maximumLendingAmount: 250000,
    showTermField: true
  },
  OVERDRAFT: {
    productName: 'overdraft',
    productDescription: 'business overdraft (£1,000 to £50,000)',
    productLimitName: 'overdraft limit',
    lendingAmountLabel: 'What would you like your overdraft limit to be?',
    minimumLendingAmount: 1000,
    maximumLendingAmount: 50000,
    showTermField: false
  },
  CREDIT_CARD: {
    productName: 'credit card',
    productDescription: 'business credit card',
    productLimitName: 'credit limit',
    lendingAmountLabel: 'What would you like your credit limit to be?',
    minimumLendingAmount: 1000,
    maximumLendingAmount: 50000,
    showTermField: false
  }
};

export default lendingTypes;
